import { render } from "./AssTeacherMaster.vue?vue&type=template&id=447977ac&scoped=true"
import script from "./AssTeacherMaster.vue?vue&type=script&lang=js"
export * from "./AssTeacherMaster.vue?vue&type=script&lang=js"

import "./AssTeacherMaster.vue?vue&type=style&index=0&id=447977ac&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-447977ac"]])

export default __exports__